import React, {useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button'
import { dataFetcher, postDataFetcher } from '../../dataFetcher'
import configData from '../../temp/config'
import CONFIG_OBJECT from '../../config/config'
import App_Constants from '../../app-constants/App_Constants'
import './AddtoCalendar.css'

const AddtoCalendar = (props) => {

  const [rdata, setRdata] = useState({
    title:null,
    itemid:null
  })

  const [itemid, setItemid] = useState(null)

  useEffect(() => {
    updatedata()
    return updatedata()
  },[props])

  const updatedata = () => {
    setRdata({
      title: props.fields.addToCalendarTitle.value,
      itemid: props.rendering.dataSource,
      NoofRecurrences: props.fields.NoofRecurrences.value && props.fields.NoofRecurrences.value
    }) 
    //setItemid(props.citemid)    
  }
  
  const addtoCalendar = (e) => {
    e.preventDefault()
    let url = `${configData.sitecoreApiHost}${CONFIG_OBJECT.ATC_REST_URL}${App_Constants.SC_API_KEY}` 
    let EventStartDate = `${props.currentMonthCycle.monthValue+1}-${props.currentMonthCycle.dayValue}-${props.currentMonthCycle.yearValue}`
    let cycleLength = props.currentMonthCycle.cycleLength
    let data= {
      CalendarItemId: rdata.itemid,
      EventStartDate: EventStartDate, 
      Interval: cycleLength,
      NoofRecurrences: rdata.NoofRecurrences
    }
    postDataFetcher(url,data)
    .then(res => {
      if (res.data.HasError) {
        console.log('Haserror: ',res.data)
      } else {
        document.calendarform.action = `${url}`+'&CalendarItemId='+data.CalendarItemId+'&EventStartDate='+data.EventStartDate+'&Interval='+data.Interval+'&NoofRecurrences='+data.NoofRecurrences
        document.calendarform.submit()
      }
    }, err => {
      console.log('Error: ',err)
    });
  }


  return(
    <>
      <div className="addtocalendar">
        <form method="post" name="calendarform" id="calendarform">
          <Button type="submit" variant="btn btn-primary" onClick={(e) => addtoCalendar(e)} disabled={props.disabled}>
            {rdata.title}
          </Button> 
        </form> 
      </div>
    </>
  )
};

export default AddtoCalendar;


